<template>
  <div class="dashboard">
    <header class="header">
      <div class="logo">
        <div class="logo-pic">
          <img v-if="isDarkTheme" :src="require('@/assets/hacker.png')" />
          <img v-else :src="require('@/assets/logo.png')" alt />
        </div>
        <span>Admin</span>
        <el-button size="mini" @click="$store.commit('TOGGLE_MENU')">
          <i class="fas fa-bars"></i>
        </el-button>
        <History />
      </div>
      <div class="options">
        <span class="username">{{ user.email }}</span>
        <ThemeBtn />
        <el-dropdown trigger="click" @command="handleCommand">
          <span class="el-dropdown-link">
            <i class="fas fa-cog" style="font-size: 1.4em"></i>
          </span>
          <el-dropdown-menu slot="dropdown" style="min-width: 150px">
            <el-dropdown-item command="signout">
              <i class="fas fa-sign-out-alt"></i>
              <span>Logout</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </header>
    <div class="content">
      <AsideMenu />
      <div class="main">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import History from '@/components/History'
import AsideMenu from '@/components/AsideMenu'
import ThemeBtn from '@/components/ThemeBtn'
import { authMixin } from '@/mixins/authMixin'
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'Dashboard',
  components: {
    History,
    AsideMenu,
    ThemeBtn,
  },
  mixins: [authMixin],
  computed: {
    ...mapGetters(['user', 'isMobile', 'isDarkTheme', 'isMaster']),
  },
  methods: {
    ...mapMutations(['TOGGLE_MENU']),
    swipeHandler(dir) {
      if (!this.isMobile) return
      if (dir == 'left') this.TOGGLE_MENU(false)
      if (dir == 'right') this.TOGGLE_MENU(true)
    },
    signout() {
      this.$store.dispatch('SIGN_OUT')
      this.logout()
    },
    handleCommand(method) {
      this[method]()
    },
  },
}
</script>
<style lang="scss" scoped>
@import '@styles';
.dashboard {
  height: 100vh;
  display: flex;
  flex-flow: column;
  position: relative;
  @include themed {
    color: t(text);
    background: t(bg);
  }

  .header {
    z-index: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 20px;
    font-weight: bold;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);

    @include themed {
      color: t(text);
      background: t(fg);
      border-bottom: 2px solid t(primary);
    }

    .logo,
    .options {
      display: flex;
      align-items: center;
      justify-content: center;
      > *:not(:last-child) {
        margin-right: 10px;
      }
    }

    .logo {
      display: flex;
      align-items: center;
      .logo-pic {
        img {
          height: 30px;
        }
      }
    }
    .username {
      font-size: 0.95 em;
    }

    @media (max-width: $break-small) {
      .username,
      .role {
        display: none;
      }
    }
  }
  .content {
    overflow: hidden;
    flex: 1 1 100%;
    display: flex;
    position: relative;
    .main {
      flex: 1 1;
      overflow: auto;
      padding: 20px;
      display: flex;
      justify-content: flex-start;
      flex-flow: column;
      & > :first-child {
        max-height: 100%;
      }
      @media (max-width: $break-small) {
        padding: 10px;
      }
    }
  }
}
</style>
